
// this is just a shim implementation of es2024: Promise.withResolvers(); but our babel transpiler option targets to an older specs,
// so before we can upgrade our options, we'll just use this one instead
export function promiseWithResolvers<T extends any>(): {promise:Promise<T>, resolve:(value: T | PromiseLike<T>) => void, reject: (reason?: any) => void} {
  const bag = {} as any
  bag.promise = new Promise<T>((resolve, reject) => {
    bag.resolve = resolve
    bag.reject = reject
  })
  return bag
}

export const inNextTick = (n?: number) => {
  const bag = promiseWithResolvers<void>()
  setTimeout(() => bag.resolve(), n)
  return bag.promise
}

